import React, { useState } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';

import { Modal, Textarea } from 'shared-components';

export interface IProps {
  offerEvidence?: string;
  onUpdate: (value: string) => void;
  onClose: () => void;
}

const EditOfferEvidenceModal = (props: IProps) => {
  const [offerEvidence, setOfferEvidence] = useState(props.offerEvidence ?? '');

  const submit = () => {
    if (offerEvidence === '') {
      return;
    }
    props.onUpdate(offerEvidence);
    props.onClose();
  };

  return (
    <Modal
      id="edit-offer-evidence"
      show={true}
      title="Update evidence used for offer"
      onClose={props.onClose}
      footer={
        <ButtonGroup size={'lg'}>
          <Button onClick={props.onClose}>Cancel</Button>

          <Button id="save-changes" onClick={submit} isDisabled={offerEvidence === ''} variant={'solid'}>
            Submit
          </Button>
        </ButtonGroup>
      }
    >
      <Textarea
        id={'offer-evidence'}
        key={'offer-evidence'}
        label="Offer text"
        value={offerEvidence}
        autoFocus={true}
        onChange={(evt: React.FormEvent<HTMLTextAreaElement>) => setOfferEvidence(evt.currentTarget.value)}
        shouldAutoResize={false}
      />
    </Modal>
  );
};

export default EditOfferEvidenceModal;
